import React from "react";
import { TrendingDown, Clock4, AlertTriangle } from "lucide-react";

const CASES = [
  {
    tag: "VAKA / FAN",
    icon: TrendingDown,
    image: "/images/case-study-1.jpg",
    title: "Fan titreşim düşürme",
    body: "Yüksek titreşim yapan endüstriyel aspiratörde sahada balans + hizalama uygulaması.",
    metric: "% 68",
    metricLabel: "Titreşim azalması",
  },
  {
    tag: "VAKA / POMPA",
    icon: Clock4,
    image: "/images/case-study-2.jpg",
    title: "Pompa rulman ömrü uzatma",
    body: "Periyodik titreşim takibi ve yağlama optimizasyonu ile rulman değişim aralığının uzatılması.",
    metric: "+ 9 ay",
    metricLabel: "Servis ömrü kazancı",
  },
  {
    tag: "VAKA / İZLEME",
    icon: AlertTriangle,
    image: "/images/case-study-3.jpg",
    title: "Online izleme ile erken uyarı",
    body: "Kritik motor üzerinde online izleme ile yatak hasarının üretim durmadan tespit edilmesi ve planlı bakıma alınması.",
    metric: "ERKEN",
    metricLabel: "Uyarı + planlı müdahale",
  },
];

export default function References() {
  return (
    <section
      id="referanslar"
      data-testid="references-section"
      className="bg-slate-50 py-20 lg:py-28 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="divider-tick"></span>
            <span className="overline">REFERANSLAR / VAKA ÖRNEKLERİ</span>
            <span className="divider-tick"></span>
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight max-w-3xl mx-auto"
            style={{ fontFamily: "Outfit" }}
          >
            Sahada ölçülen sonuçlar.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CASES.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={i}
                data-testid={`reference-card-${i + 1}`}
                className="ind-card overflow-hidden card-lift"
              >
                <div className="relative h-44 overflow-hidden bg-slate-100">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                  <span className="absolute top-3 left-3 font-mono-accent text-[10px] tracking-[0.22em] text-cyan-300 bg-slate-900/80 px-2 py-1 rounded-sm">
                    {c.tag}
                  </span>
                  <div className="absolute top-3 right-3 w-9 h-9 grid place-items-center bg-slate-900/85 rounded-sm">
                    <Icon className="w-4 h-4 text-cyan-400" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="p-7">
                  <h3
                    className="text-xl font-bold text-slate-900 mb-3"
                    style={{ fontFamily: "Outfit" }}
                  >
                    {c.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed mb-6 min-h-[60px]">
                    {c.body}
                  </p>
                  <div className="border-t border-dashed border-slate-200 pt-4 flex items-end justify-between">
                    <div>
                      <div className="font-mono-accent text-3xl font-bold text-slate-900 leading-none">
                        {c.metric}
                      </div>
                      <div className="text-xs text-slate-500 mt-1 uppercase tracking-wider">
                        {c.metricLabel}
                      </div>
                    </div>
                    <span className="text-[10px] font-mono-accent text-slate-400 tracking-[0.2em]">
                      CASE / {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
